import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import { mainSlider } from "../../../services/script";

class SpecialOffer extends Component{
    render(){
        const { themeLayoutId, mainBanner } = this.props;
        return(
            <React.Fragment>

                {/* Furniture Theme */}

                {themeLayoutId === 'L02' &&
                <section className="p-b-0 section-t-space">
                    <div className="full-banner parallax parallax-banner3  text-center p-center" style={{ backgroundImage: "url('https://react.pixelstrap.com/assets/images/parallax/3.jpg')" }}>
                    <div className="container">
                    <div className="row">
                        <div className="col">
                        <div className="banner-contain">
                            <h2>2018</h2>
                            <h3>interior design in home</h3>
                            <h4>special offer</h4>
                        </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </section>
                }

                {/* end Furniture Theme */}

                {/* Kids Theme */}

                {themeLayoutId === 'L05' && 
                    <React.Fragment>
                    <section className="p-0">
                        <div className="full-banner parallax parallax-banner11 text-center p-left" style={{ backgroundImage: "url('https://react.pixelstrap.com/assets/images/parallax/11.jpg')" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        <div className="banner-contain">
                                            <h2>2018</h2>
                                            <h3>top trends</h3>
                                            <h4>special offer</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div>
                        <section className="">
                            <div className="container">
                                <div className="row multiple-slider">

                                    {/* Product List */}
                                        <div className="col-lg-3 col-sm-6">
                                            <div className="theme-card">
                                                <h5 className="title-border">new products</h5>
                                                <Slider {...mainSlider} className="offer-slider slide-1">
                                                {!!mainBanner && mainBanner.map((infocus) => {
                                                        return (
                                                            <div key={infocus.Image.APP_PAGE_ID}>
                                                                {/* Media */}
                                                                <div className="media">
                                                                    <Link to="/multikart/left-sidebar/product/124">
                                                                        <img className="img-fluid" src="https://react.pixelstrap.com/multikart/assets/images/kids/product/10.jpg" alt="" />
                                                                    </Link>
                                                                <div className="media-body align-self-center">
                                                                    <div className="rating"><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i></div>
                                                                    <Link to="/multikart/left-sidebar/product/124">
                                                                        <h6>Dog Orthopadic</h6>
                                                                    </Link>
                                                                    <h4>$175<del><span className="money">$350</span></del></h4>
                                                                </div>
                                                                </div>
                                                                {/* end Media */}
                                                                {/* Media */}
                                                                <div className="media">
                                                                    <Link to="/multikart/left-sidebar/product/125">
                                                                        <img className="img-fluid" src="https://react.pixelstrap.com/multikart/assets/images/kids/product/11.jpg" alt="" />
                                                                    </Link>
                                                                    <div className="media-body align-self-center">
                                                                        <div className="rating"><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i><i className="fa fa-star"></i></div>
                                                                        <Link to="/multikart/left-sidebar/product/125">
                                                                            <h6>Dog Crock</h6>
                                                                        </Link>
                                                                        <h4>$65<del><span className="money">$130</span></del></h4>
                                                                    </div>
                                                                    </div>
                                                                {/* end Media */}
                                                                
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Slider>
                                            </div>
                                                
                                        </div>             
                                    {/* end Product List */}
                                
                                </div>
                            </div>
                        </section>
                    </div>
                </React.Fragment>
                }
                {/* end Kids Theme */}

            </React.Fragment>
        )
    }
}



export default SpecialOffer;